import { render } from "./edittemplatefieldpopup.vue?vue&type=template&id=9438271e&scoped=true"
import script from "./edittemplatefieldpopup.vue?vue&type=script&lang=js"
export * from "./edittemplatefieldpopup.vue?vue&type=script&lang=js"

import "./edittemplatefieldpopup.vue?vue&type=style&index=0&id=9438271e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9438271e"]])

export default __exports__